<template>
    <div class="cell auto" style="padding:10px"> 

        <div style="position: relative;height:70px;margin-bottom:15px">
                <div class="qlargecircularimage qheadercolour" style="position:absolute;left:0px;top:5px"><img style="height:55px;width:55px" src="/assets/icons/horses-mouth.png"/></div>
                   <div  style="padding-top:5px; padding-left:17px;padding-right: 4px">

                        <h1 class="qmajorheader qalignmiddle " v-html="langConv('Bookmaker News')"></h1>
                        <h2 class="qsubheader qalignmiddle qsmallfontplus1" v-html="langConv('Bonuses, odds, insights and trivia')"></h2>
            
                   </div>
        </div>

   
       <searchcriteria  @criteria="configChanged" searchtype="dateandsearchonly" >  </searchcriteria>

        <!-- tabs here  -->

        <tabs @changed="tabChanged"  v-if="results.length>0" :tabtype="$tabtype.textbelowimage">
            <div v-for="(row, i2) in results" :key="i2" >
                <tab :title=row.Title :img=row.img :colour="row.colour" :id=i2 :description="row.D" :isactive=false></tab>
            </div>
        </tabs>
    
        <blogview view="full" :startdate="startdate" :enddate="enddate" :blogsection="section" :specifictext="searchdesc"/>
        
    </div>
</template>

<script>
import blogview from '../components/components/blogview.vue' 
import searchcriteria from '../components/components/searchcriteria.vue'
import tab from '../components/modified3rdpartycomponents/tab.vue'
import tabs from '../components/modified3rdpartycomponents/tabs.vue'

export default {
    name: "fullpagehorsesmouth",
        metaInfo() {
  
        const baseUrl = process.env.VUE_APP_WEBSITE || ''
        const path = (this.$route && this.$route.fullPath) ? this.$route.fullPath : '/'         
        return {
            title: this.langConv("Bookmaker News") + " | Oddsgalore" ,
            meta: [{
        
                vmid: 'description',
                name: 'description',
                content: this.langConv("The Lastest Bookmaker and Odds News, up to date All Punter Offers")
            },
            {
                vmid: 'og:title',
                property: 'og:title',
                content: this.langConv("Bookmaker News") 
            },    
            ],
                link: [{
                vmid: 'canonical',
                rel: 'canonical',
                href: baseUrl + path
            }]
        }
    },
              

         data() {
            return {
                results: [],
                currenttab: 0,
                startdate: new Date("1977/1/1"),
                enddate: new Date("2099/1/1"),
                section: "all",
                searchdesc: ""     
            }
         },



    props: {
        param1: {type: String, default: "full"}
    },

    components: {
        blogview,
        searchcriteria,
        tabs,
        tab
    },
    created() {
        if (!this.$store.state.wasSSR) {
        
            this.getTabData();
        }
    },

    methods: {
    
      async getTabData() {

                let params = '[]';
                let url = process.env.VUE_APP_WEBAPI  + "FeatureTables.svc/RetrieveGenericGet";
                let spname = "GetHorsesMouthTypes_NS";

                //get bet results for that bet
                this.newgenericresultset(url, params,spname).then(response => { this.results = response; 
                
                 if (typeof window !== 'undefined') { 
                    window.__PRERENDER_READY = true;
                 }
                })
              
       },

        tabChanged: function(tab) {

            if (tab != this.currenttab) {
                 this.currenttab = tab
                 this.section = String(this.results[tab].Title || '').replace(/ /g, '')
              
            }

        },

        configChanged: function (fromdate,todate,selectedusers,selectedstrategies,trendonly = false,individualbets = false,topn = 999,ascend=false, searchdesc) {
          
            this.startdate = fromdate;
            this.enddate = todate;
            this.searchdesc = searchdesc;
     

        }

    }


}
</script>

<style scoped>

</style>
